module.exports = __webpack_public_path__ + "img/Hybrid-D-3.48b70493.jpg";